import React from 'react';
import {Flex} from "./styled/Flex";
import {Text} from "./styled/Text";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationCircle, faExclamationTriangle} from "@fortawesome/free-solid-svg-icons";
import {PaperLayout} from "./styled/PaperLayout";

const errorIcons: Record<string, React.ReactElement<any>> = {
    'warning': <FontAwesomeIcon icon={faExclamationTriangle} color={'orange'} size={'2x'}/>,
    'error': <FontAwesomeIcon icon={faExclamationCircle} color={'red'} size={'2x'}/>
};

export const errorMessage: Record<string, string> = {
    "403": "L'utente non ha i permessi ad eseguire richiesta ",
    "400": "Richiesta Errata",
    "401": "Utente non autorizzato",
    "404": "Elemento non Trovato",
    "405": "Method Not Allowed",
    "406":  "Not Acceptable",
    "407": "Proxy Authentication Required",
    "408": "Request Timeout",
    "409": "Conflitto sulla Risorsa",
    "410": "Gone",
    "411": "Length Required",
    "412": "Precondition Failed (RFC 7232)",
    "413": "Payload Too Large (RFC 7231)",
    "414":"URI Too Long (RFC 7231)",
    "415": "Unsupported Media Type",
    "416": "Range Not Satisfiable (RFC 7233)",
    "417": "Expectation Failed",
    "426": "Upgrade Required",
    "428": "Precondition Required (RFC 6585)",
    "429": "Too Many Requests (RFC 6585)",
    "431": "Request Header Fields Too Large (RFC 6585)",
    "451": "Unavailable For Legal Reasons (RFC 7725",
    "500": "Internal Server Error",
    "501": "Not Implemented",
    "502": "Bad Gateway",
    "503": "Servizio al momento non Disponibile",
    "504": "Gateway Timeout",
    "505": "HTTP Version Not Supported",
    "900": "Servizio momentaneamente non disponibile, si prega di riprovare in seguito"
};


interface  ErrorMessageInterface {
    kind: 'error' | 'warning';
    message: string;
    asCard?: boolean;
}

const ErrorMessage: React.FC<ErrorMessageInterface> = (props) => {
    const asCard = (props.asCard ?? true);
  return (
      <PaperLayout asCard={asCard}>
        <Flex direction={'row'} justify={'flex-start'}>
            <Text marginRight={'10px'}>{errorIcons[props.kind]}</Text>
            <Text fontSize={'1.2rem'}>{props.message}</Text>
        </Flex>
      </PaperLayout>
  )  
};

export default ErrorMessage;